import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

export type ListPageStateVariant = 'loading' | 'empty' | 'error'

@Component({
	selector: 'app-list-page-state',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
	templateUrl: './list-page-state.component.html',
	styleUrl: './list-page-state.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPageStateComponent {
	readonly variant = input.required<ListPageStateVariant>()
	readonly message = input<string>('')
	readonly icon = input<string>('group_off')
	readonly retryLabel = input<string>('Reintentar')

	readonly retry = output<void>()
}
